/**
 * @module components\subroute\Explore
 */
import Vue from "vue";
import Component from "vue-class-component";
import AgilityDetails from "@/components/AgilityDetails/AgilityDetails.vue";
import JobDetails from "@/components/JobDetails/JobDetails.vue";
import PaymentDetails from "@/components/PaymentDetails/PaymentDetails.vue";
import TechnologyDetails from "@/components/TechnologyDetails/TechnologyDetails.vue";
import BankingDetails from "@/components/BankingDetails/BankingDetails.vue";
import TravelDetails from "@/components/TravelDetails/TravelDetails.vue";
import RechargeDetails from "@/components/RechargeDetails/RechargeDetails.vue";
import { globalMutations } from "@/store";
import store from "@/store";

@Component({
  components: {
    BankingDetails,
    AgilityDetails,
    JobDetails,
    PaymentDetails,
    TechnologyDetails,
    TravelDetails,
    RechargeDetails
  }
})
export default class Explore extends Vue {
  initialScroll = false;

  // handleScroll(event: any) {
  //   // Any code to be executed when the window is scrolled
  //   console.log(event);
  // }
  // created() {
  //   window.addEventListener("scroll", this.handleScroll);
  // }
  // destroyed() {
  //   window.removeEventListener("scroll", this.handleScroll);
  // }
  curSecIndex = 0;
  direction = "top";
  fab = false;
  fab2 = false;
  fling = false;
  hover = true;
  tabs = null;
  top = false;
  right = true;
  bottom = true;
  left = false;
  transition = "slide-x-reverse-transition";
  dialog = false;
  notifications = false;
  sound = true;
  widgets = false;
  selectedModal = "";
  $ksvuefp: any;
  sections = [
    {
      id: 1,
      any_data: "Banking Services",
      any_data_sub: "to the Underserved",
      any_data2: "Bridging the digital divide",
      img_data: "poor6.jpg",
      img_mb_data: "poor6-mb.jpg",
      bgColor: "#df9926",
      bgType: "cover",
      bgTypeMb: "contain ",
      left: true,
      navTitle: "Banking Services",
      modalId: "banking"
    },
    {
      id: 2,
      any_data: "Payment Services",
      any_data2: "We support payment services such as",
      anyList: ["Aadhaar Pay", "UPI", "QR Scan"],
      img_data: "cash4.jpg",
      img_mb_data: "cash4-mb.jpg",
      bgColor: "#0f9ffa",
      bgType: "cover",
      bgTypeMb: "contain ",
      left: true,
      navTitle: "Payment Services",
      modalId: "payment"
    },
    {
      id: 3,
      any_data: "Technology ",
      any_data_sub: "Innovation",
      any_data2: "Multiple Products under one roof",
      img_data: "techinno2.jpg",
      img_mb_data: "techinno2-mb.jpg",
      bgColor: "#963596",
      bgType: "cover",
      bgTypeMb: "contain ",
      left: true,
      navTitle: "Technology Innovation",
      modalId: "technology"
    },

    {
      id: 6,
      any_data: "Travel Services",
      any_data2: "We are providing various Travel Services",
      anyList: [
        "Booking with IRCTC",
        "Domestic & International Flights booking services.",
        "Book a Hotel"
      ],
      img_data: "travel2.jpg",
      img_mb_data: "travel2-mb.jpg",
      bgColor: "#23b7a1",
      bgType: "cover",
      bgTypeMb: "contain ",
      left: true,
      navTitle: "Travel Services",
      modalId: "travel"
    },
    {
      id: 7,
      any_data: "Recharges &",
      any_data_sub: "Bill Payments",
      any_data2: "We are supporting more than 100+ Billers",
      anyList: ["Electricity Bills", "Recharges", "Payments"],
      img_data: "recharges2.jpg",
      img_mb_data: "recharges2-mb.jpg",
      bgColor: "#23b7a1",
      bgType: "cover",
      bgTypeMb: "contain ",
      left: true,
      navTitle: "Recharges & Payments",
      modalId: "recharge"
    },
    {
      id: 4,
      any_data: "Agility at Scale",
      any_data2: "We support",
      anyList: ["Our Own APIs", "Alliances"],
      img_data: "agility5.jpg",
      img_mb_data: "agility5-mb.jpg",
      bgColor: "#23b7a1",
      bgType: "cover",
      bgTypeMb: "contain ",
      left: true,
      navTitle: "Agility at scale",
      modalId: "agility"
    },

    {
      id: 5,
      any_data: "Creating New",
      any_data_sub: "Job Avenues",
      any_data2: "One million job opportunities",
      img_data: "createjobs3.jpg",
      img_mb_data: "createjobs3-mb.jpg",
      bgColor: "#2698cf",
      bgType: "cover",
      bgTypeMb: "contain ",
      left: true,
      navTitle: "Creating Jobs",
      modalId: "jobs"
    }
  ];
  // See below for a list of default options
  options = {
    animationType: "slideY",
    duration: 1000,
    easing: "easeInOutQuad",
    loopBottom: true,
    loopTop: true,
    overlay: false,
    dotNavEnabled: false,
    preloaderEnabled: false,
    parallax: true,
    waitForBackgrounds: true
  };

  preload() {
    var images = new Array();
    for (let i = 0; i < this.preload.arguments.length; i++) {
      images[i] = new Image();
      images[i].src = this.preload.arguments[i];
    }
  }

  // preload(
  // 			"http://domain.tld/gallery/image-001.jpg",
  // 			"http://domain.tld/gallery/image-002.jpg",
  // 			"http://domain.tld/gallery/image-003.jpg"
  // 		)

  swipe(direction: any) {
    if (direction == "Top") {
      alert("top");
    } else if (direction == "Bottom") {
      alert("bottom");
    }
  }

  exploreModal(modalId: string) {
    this.selectedModal = modalId;
    store.commit(globalMutations.detailModal);
  }
}
